import { useMutation, useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { handleResponse, queryClient } from "./setup";
import Noti from "../../view/components/general/noti";
import { ROUTES } from "../../constants";
import { AnnouncementsService } from "../../services/requests/announcements";
import { ProviderTaminService } from "../../services/requests/providerTamin";
import { useState } from "react";

const useGetTaminAuth = (params: any, modalName?: boolean) => {
  return useQuery({
    queryKey: ["getTaminAuth", params],
    queryFn: ({ queryKey }: any) => {
      const [_, params] = queryKey;
      return ProviderTaminService.getTaminAuth(params);
    },
    enabled: modalName ?? true,
  });
};

// const useVerifyTaminAuth = (params: any, modalName?: boolean) => {
//   return useQuery({
//     queryKey: ["getVerifyTaminAuth", params],
//     queryFn: ({ queryKey }: any) => {
//       const [_, params] = queryKey;
//       return ProviderTaminService.verifyTaminAuth(params);
//     },
//     enabled: !!params// modalName ?? true,
//   });
// };

const useVerifyTaminAuth = () => {
  return useMutation({
    mutationFn: ProviderTaminService.verifyTaminAuth,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          // console.log(data);
          // Noti("success", data?.data?.msg)
        },
      });
    },
    onError: (error) => {
      Noti("error", error?.message);
    },
  });
};

const useGetTaminAuthStatus = () => {
  return useMutation({
    mutationFn: ProviderTaminService.getTaminAuthStatus,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          Noti(
            "success",
            "استعلام وضعیت اتصال به تامین اجتماعی با موفقیت انجام شد",
          );
        },
      });
    },
    onError: (error) => {
      Noti("error", "استعلام وضعیت اتصال به تامین اجتماعی ناموفق بود" + error);
    },
  });
};
// const useVerifyTaminAuth = () => {
//   const [code, setCode] = useState<string | null>(null);
//   const [providerId, setProviderId] = useState<number | null>(null);

//   console.log("TAMIN_10", code);
//   console.log("TAMIN_101", providerId);
//   const query = useQuery({
//     queryKey: ["getVerifyTaminAuth", code],
//     queryFn: () => {
//       if (!code || !providerId) {
//         Noti("error", "مقادیر توکن و پزشک بطور کامل مقداردهی نشده‌اند");
//         throw new Error("Missing required values");
//       }
//       return ProviderTaminService.verifyTaminAuth({ code, providerId });
//     },
//     enabled: !!code && !!providerId, // only runs when code is set
//   });

//   return {
//     ...query,
//     run: (newCode: string, providerId: number) => {
//       setCode(newCode);
//       setProviderId(providerId);
//     },
//   };
// };

const useGetTaminReferralCount = (params: any, modalName?: boolean) => {
  return useQuery({
    queryKey: ["getTaminReferralCount", params],
    queryFn: ({ queryKey }: any) => {
      const [_, params] = queryKey;
      return ProviderTaminService.getTaminReferralCount(params);
    },
    enabled: modalName ?? true,
  });
};

const useGetTaminReferralByTrackingCode = (
  patientId: number,
  trackingCode: number,
  modalName?: boolean,
) => {
  return useQuery({
    queryKey: ["getTaminReferralByTrackingCode", trackingCode],
    queryFn: ({ queryKey }: any) => {
      const [_, trackingCode] = queryKey;
      return ProviderTaminService.getTaminReferralByTrackingCode(
        patientId,
        trackingCode,
      );
    },
    enabled: modalName ?? true,
  });
};

export {
  useGetTaminAuth,
  useVerifyTaminAuth,
  useGetTaminAuthStatus,
  useGetTaminReferralCount,
  useGetTaminReferralByTrackingCode,
};
